import { currencySymbol } from './constants';

export default ({ amount, currency }) => {
  if (!amount) {
    return null;
  }
  const formatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2 });
  const formatted = formatter.format(Math.abs(amount));
  const sign = amount < 0 ? '-' : '';
  const symbol = currencySymbol[currency];
  return symbol === undefined
    ? `${sign}${formatted} ${currency}`
    : `${sign}${symbol}${formatted}`;
};
